<div class="custom-list">
  <!-- Loading overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <p class="loading-message">{{ loadingMessage }}</p>
    </div>
  </div>

  <table mat-table
         matSort
         [dataSource]="dataSource"
         (matSortChange)="onSortChange($event)"
         [class.loading]="isLoading">
    <ng-container *ngFor="let column of columns"
                  [matColumnDef]="column.key">
      <th mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          [disabled]="!column.sort"
          [style.width]="column.width"
          [style.max-width]="column.width"
          [style.min-width]="column.width">
        {{ column.label }}
      </th>
      <td mat-cell 
          *matCellDef="let element"
          [style.width]="column.width"
          [style.max-width]="column.width"
          [style.min-width]="column.width"
          [style.word-wrap]="'break-word'"
          [style.overflow-wrap]="'break-word'"
          [style.white-space]="'normal'">
        <ng-container *ngIf="column.template; else defaultCell">
          <ng-container *ngTemplateOutlet="column.template; context: { $implicit: element }"></ng-container>
        </ng-container>
        <ng-template #defaultCell>
          <ng-container *ngIf="column.valueTransform; else noTransform">
            <div class="cell-content" [innerHTML]="column.valueTransform(element[column.key], element)"></div>
          </ng-container>
          <ng-template #noTransform>
            <div class="cell-content" [innerHTML]="element[column.key]"></div>
          </ng-template>
        </ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [class.selected]="dataSource.isSelected(row)"
        (click)="dataSource.onRowClick(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        {{ emptyMessage }}
      </td>
    </tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="dataSource.pageSizeOptions"
    [pageSize]="dataSource.pageSize"
    [length]="dataSource.totalItems"
    [pageIndex]="dataSource.pageIndex"
    (page)="dataSource.pageChanged($event)">
  </mat-paginator>
</div>
